import React from 'react';
import ReactDOM from 'react-dom';
import { Message } from 'oskari-ui';
Oskari.clazz.define('Oskari.inspire.Flyout', function (instance) {
  this.instance = instance;
  this.container = null;
  this.flyout = null;
}, {
  __name: 'Oskari.inspire.Flyout',
  getName: function getName() {
    return this.__name;
  },
  getTitle: function getTitle() {
    return this.instance.loc('flyout.title');
  },
  setEl: function setEl(el, flyout, width, height) {
    this.container = el[0];
    this.flyout = flyout;
    this.container.classList.add('inspire');
    this.flyout.addClass('inspire');
    this.flyout.css('max-width', '700px');
  },
  /**
   * Renders content for flyout UI
   * @method createContent
   */
  createContent: function createContent() {
    var root = this.container;
    if (!root) {
      return;
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(Message, {
      bundleKey: this.instance.getName(),
      messageKey: "flyoutContent.content",
      allowHTML: true
    }), root);
  },
  startPlugin: function startPlugin() {}
});